import { request } from '@/shared/api/request'

export const sendEmployeeListSign = ({data, params}) => {
	return request({ url: 'staff/wplace/send', method: 'POST', data, params })
}
